import { defineComponent, createBlock, openBlock, unref, withCtx, createElementBlock, mergeProps, renderSlot } from "vue";
import { MenuItem } from "@headlessui/vue";
const _hoisted_1 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "FlowDropdownItem",
  props: {
    disabled: { type: Boolean },
    checked: { type: Boolean },
    href: {}
  },
  emits: ["click"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(MenuItem), { disabled: _ctx.disabled }, {
        default: withCtx(({ active }) => [
          _ctx.href ? (openBlock(), createElementBlock("a", mergeProps({ key: 0 }, _ctx.$attrs, {
            class: ["item", { active, disabled: _ctx.disabled, checked: _ctx.checked }],
            href: _ctx.href,
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
          }), [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 16, _hoisted_1)) : (openBlock(), createElementBlock("button", mergeProps({ key: 1 }, _ctx.$attrs, {
            class: ["item", { active, disabled: _ctx.disabled, checked: _ctx.checked }],
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click", $event))
          }), [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 16))
        ]),
        _: 3
      }, 8, ["disabled"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowDropdownItem.vue2.js.map
